import axios from 'axios'

export const getSecurityInfo = () => {
  return axios.get('/auth/security-info')
}

export const submitChangePasswordForm = ({ oldPassword, newPassword }) => {
  return axios.post('/auth/change-password', {
    oldPassword,
    newPassword,
  })
}

export const submitChangeSecurityQuestionForm = ({ password, recoveryQuestion, recoveryAnswer }) => {
  return axios.put('/auth/security-question-answer', {
    password,
    recoveryQuestion,
    recoveryAnswer,
  })
}

export const getMfaFactorInfo = () => {
  return axios.get('/auth/okta/mfa-factors')
}

export const postMfaUserFactor = (data) => {
  return axios.post('/auth/okta/user-factors', data)
}

export const resetUserMfa = (factorType) => {
  return axios.post('/auth/okta/reset-user-factor', { factorType })
}

export const activationLinkMfa = ({ type, factorType, factorId, phone }) => {
  return axios.post('/auth/okta/activation-link', { type, factorType, factorId, phone })
}

export const activateFactor = ({ factorId, passCode }) => {
  return axios.post('/auth/okta/activate-factor', { factorId, passCode })
}

export const challengeUserFactor = ({ factorId, passCode }) => {
  return axios.post('/auth/okta/challenge-user-factor', { factorId, passCode })
}

export const enrollUserMfa = ({ factorType, provider, phone }) => {
  return axios.post('/auth/okta/enroll-user-factor', {
    factorType,
    provider,
    phone,
  })
}

export const resendSms = ({ factorId, factorType, provider, phone }) => {
  return axios.post('/auth/okta/resend-sms', {
    factorId,
    factorType,
    provider,
    phone,
  })
}

export const pollMfaVerify = ({ factorId, transactionId }) => {
  return axios.post('/auth/okta/poll-verify', { factorId, transactionId })
}
